import { Dispatch, createContext, useContext, useReducer } from "react";
export type SignUpForm = {
  name: string;
  phone: string;
  code: string;
  countryCode: string;
  error: Error | null;
  resendCodeLoading: boolean;
};
const initialState: SignUpForm = {
  name: "",
  phone: "",
  code: "",
  countryCode: "",
  error: null,
  resendCodeLoading: false
};
type SetPhoneAction = {
  type: "SET_PHONE";
  payload: {
    value: string;
  };
};
const setPhoneAction = (value: string): SetPhoneAction => ({
  type: "SET_PHONE",
  payload: {
    value
  }
});
type SetCodeAction = {
  type: "SET_CODE";
  payload: {
    value: string;
  };
};
const setCodeAction = (value: string): SetCodeAction => ({
  type: "SET_CODE",
  payload: {
    value
  }
});
type SetErrorAction = {
  type: "SET_ERROR";
  payload: {
    value: Error | null;
  };
};
const setErrorAction = (value: Error | null): SetErrorAction => ({
  type: "SET_ERROR",
  payload: {
    value
  }
});
type SetResendCodeLoadingAction = {
  type: "SET_RESEND_CODE_LOADING";
  payload: {
    value: boolean;
  };
};
const setResendCodeLoadingAction = (value: boolean): SetResendCodeLoadingAction => ({
  type: "SET_RESEND_CODE_LOADING",
  payload: {
    value
  }
});
type SetCountryCodeAction = {
  type: "SET_COUNTRY_CODE";
  payload: {
    value: string;
  };
};
const setCountryCodeAction = (value: string): SetCountryCodeAction => ({
  type: "SET_COUNTRY_CODE",
  payload: {
    value
  }
});
type SetNameAction = {
  type: "SET_NAME";
  payload: {
    value: string;
  };
};
const setNameAction = (value: string): SetNameAction => ({
  type: "SET_NAME",
  payload: {
    value
  }
});
export type Actions = SetPhoneAction | SetCodeAction | SetErrorAction | SetResendCodeLoadingAction | SetCountryCodeAction | SetNameAction;
const SignUpContext = createContext<{
  state: SignUpForm;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null
});
function useSignUp() {
  return useContext(SignUpContext);
}
function reducer(state = initialState, action: Actions): SignUpForm {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case "SET_PHONE":
      return {
        ...state,
        phone: payload.value
      };
    case "SET_CODE":
      return {
        ...state,
        code: payload.value
      };
    case "SET_ERROR":
      return {
        ...state,
        error: payload.value
      };
    case "SET_RESEND_CODE_LOADING":
      return {
        ...state,
        resendCodeLoading: payload.value
      };
    case "SET_COUNTRY_CODE":
      return {
        ...state,
        countryCode: payload.value
      };
    case "SET_NAME":
      return {
        ...state,
        name: payload.value
      };
    default:
      return state;
  }
}
type SignUpProviderProps = {
  initialFormValues: Partial<SignUpForm>;
  children: React.ReactNode;
};
const SignUpProvider = ({
  children,
  initialFormValues
}: SignUpProviderProps) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...initialFormValues
  });
  return <SignUpContext.Provider value={{
    state,
    dispatch
  }} data-sentry-element="unknown" data-sentry-component="SignUpProvider" data-sentry-source-file="context.tsx">
      {children}
    </SignUpContext.Provider>;
};
export { reducer, initialState, SignUpProvider, SignUpContext, useSignUp, setPhoneAction, setCodeAction, setErrorAction, setResendCodeLoadingAction, setCountryCodeAction, setNameAction };